var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.258)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBE76A",
    d: "M45.056 21.156c-1.976.931-4.358.139-5.322-1.77-.963-1.909-.143-4.21 1.833-5.142 1.975-.93 4.358-.138 5.321 1.77.964 1.91.143 4.212-1.832 5.142Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.056 21.156c-1.976.931-4.358.139-5.322-1.77.919.768 2.772 1.48 5.029.356 2.257-1.125 2.214-2.686 2.125-3.727.964 1.909.143 4.21-1.832 5.141Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBC7A2",
    d: "M26.423 13.036c1.284 3.177 3.527 5.336 6.765 6.753l-2.48 2.396c-1.728 1.67-3.764 2.987-5.994 3.88l-.518.198-4.585-4.43c.92-2.349 2.337-4.472 4.152-6.226l2.66-2.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.916 0c.4 1.325 1.412 2.756 2.762 4.06 1.318 1.274 2.754 2.229 4.079 2.62l-11.51 11.12c-.242.234-.52.408-.814.522-3.268-1.3-5.38-3.337-6.497-6.48.113-.268.278-.52.493-.741l11.487-11.101Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBC7A2",
    points: "21.785 18.972 27.157 24.162 8.068 40.075 5.316 37.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBC7A2",
    d: "m1.293 39.5 5.467-.095c.552-.009 1.007.43 1.017.983 0 .012 0 .023 0 .034l-.03 1.734c-.01.538-.444.973-.983.982l-5.467.094c-.552.01-1.007-.43-1.017-.982 0-.012 0-.023 0-.035l.03-1.733c.01-.539.444-.973.983-.983Z",
    transform: "rotate(45 4.028 41.319)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.298,
    cy: 4.702,
    fill: "#EBC7A2",
    rx: 4.781,
    ry: 1.869,
    transform: "rotate(45 45.298 4.702)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftball);
export default __webpack_public_path__ + "static/media/softball.fa8a41f29b5deb740446b82e8b0a7afb.svg";
export { ForwardRef as ReactComponent };